import { ManageMessageCategoryResult } from 'modules/dragAndDropEditor/hooks/useManageMessageCategories';

export const getManageMessageCategoriesNames = (categories: ManageMessageCategoryResult[]) =>
  categories.reduce((acc, category, i) => {
    const delimiter = i === 0 ? '' : ', ';
    return `${acc}${delimiter}${category?.name}`;
  }, '');
